export function inRange(num: number, start: number, end: number): boolean {
  // Ensure start is always less than end for consistent comparison
  const [min, max] = start < end ? [start, end] : [end, start];

  return num >= min && num <= max;
}
